<template>
    <ul class="iu-nav">
        <slot></slot>
    </ul>
</template>

<script>
export default {
    name: 'IuNav',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iu-nav {
    display: flex;
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    background-color: #fff;
    border-bottom: solid 1px #e6e6e6;
}
</style>
